import * as types from '../mutation-types'
export const getDefaultState = ()=>{
    return {
       pre_invoice: [],
       print_click : false
    }
}
export const state = {
    pre_invoice:[]
}
export const getters = {
    pre_invoice : state => state.pre_invoice
}
export const mutations = {
    [types.FETCH_PRE_INVOICE_ITEM](state,payload){
        state.pre_invoice = payload
    },
    [types.RESET_PRE_INVOICE_ITEM](state,payload){
        Object.assign(state, getDefaultState());
    }
}
export const actions = {
    setPreInvoiceItems({commit},payload){
        commit(types.FETCH_PRE_INVOICE_ITEM,payload);
    },
    resetPreInvoiceItems({commit},payload){
        commit(types.RESET_PRE_INVOICE_ITEM,payload);
    }
}